import styled from 'styled-components';
import { color } from 'styles/pallete';

interface ContainerProps {
	$pTop: number;
	$pBottom: number;
}

export const container = styled.div<ContainerProps>`
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	padding: ${(props) => (props.$pTop === 0 ? '10px' : `${props.$pTop}px`)} 0px
		${(props) => (props.$pBottom === 0 ? '10px' : `${props.$pBottom}px`)} 10px;
	gap: 1rem;
	background-color: ${color.interface.white};
	transition: all ease 0.5s;
`;

export const lisStories = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	overflow: auto;
`;

interface StorieProps {
	$isSquare: boolean;
}

export const storie = styled.div<StorieProps>`
	width: fit-content;
	height: fit-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;

	> img {
		border: 3px solid ${color.interface.pinkMofiq};
		width: 6rem;
		height: 6rem;
		border-radius: ${(props) => (props.$isSquare ? '8px' : '50%')};
		object-fit: contain;
	}

	> p {
		font-family: nunito-light;
		font-weight: 900;
		text-align: center;
		color: ${color.interface.blackMofiq2};
	}
`;
